import { useEffect, useState } from "react";
import Button from "../../components/button";
import Modal from "../../components/modal";
import Styles from "./styles.module.scss"
import { getAPI, postAPI, uploadApi } from "../../api/api";
import { REACT_APP_CANDIDATE_FRELLANCER, REACT_APP_CONTRACT } from "../../utils/common";
import ContractDetails from "../contractDetails";
import { getMilliSecUTC } from "../../utils/EllowUtils";
import { contractMetadata, updateProject , getContractMetadataHistory, previousContractDetails } from './services'
import ConfirmationModal from '../../modal/confirmation/terminateContractConfirmationModal'
import mixpanelData from "../../utils/mixpanel";
import { getProjects, getProjectDetails } from "./services";
import ContractAgreement from "../contractAgreement";
import NotificationAlert from "../../components/notification";
import { Icon } from "@iconify/react";
import UploadFiled from "../../components/fileduploader";
import * as Utils from '../../utils/EllowUtils';

const { v4: uuidv4 } = require("uuid");

interface props {
    submit?: any
    onClose?:  any
    candidateJobId: string 
    allocatedTo: any
    getTableValues: any
    closed: any
    hrEmail: any
    prevCandidateJobId?: string;
    prevContract?: any
    version?: any
}


const  ResourceInfoModal: React.FC<props> = ({
    submit,
    onClose,
    candidateJobId,
    allocatedTo,
    getTableValues,
    closed,
    prevCandidateJobId,
    hrEmail,
    prevContract,
    version
}) => {

    const [contractValues, setContractValues] = useState<any>('')
    const [employeeId, setEmployeeId] = useState<any>('')
    const [ timesheetSubmitted ,setTimesheetSubmitted ] = useState(false)
    const [projectValues, setProjectValues] = useState<any>('')
    const [IdGroup, setIdGroup] = useState<any>('')
    const [contractSigned, setcontractSigned] = useState<boolean>(false)
    const [contractDetails, setContractDetails] = useState<boolean>(false)
    const [confirmationModal, setConfirmationModal] = useState<boolean>(false)
    const [buttonName, setButtonName] = useState<string>('Save')
    const [fullDetails, setFullDetails] = useState<any>()
    const [terminateComment , setTerminateComment] = useState<any>()
    const [projectList, setProjectList] = useState<any>()
    const [disableButton, setDisableButton] = useState<boolean>(false)
    const [agreement, setAgreement] = useState<boolean>(false)
    const [agreementValues, setAgreementValues] = useState<any>()
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [type, setType] = useState<string>('success')
    const [icon, setIcon] = useState<boolean>(false)
    const [signed, setSigned] = useState<boolean>(false)
    const [signDetails, setSignedDetails] = useState<any>()
    const [contractInitiatedDate , setContractInitiatedDate] = useState<any>()
    const [revisedCheckValues, setRevisedCheckValues] = useState<{ startDate: number, endDate: number, candidateRate: number,  resourceCost: number}>({ startDate: 0, endDate: 0, candidateRate: 0, resourceCost: 0 })
    const [revisedContract, setRevisedContract] = useState<boolean>(false)
    const [skillList, setSkillList] = useState<any>()

    useEffect(() => {
        
        if(prevContract === false){
            getContractDetails()
        }else{
            getPreviousContract()
        }
        getAPI('https://api.ellow.io/common/api/v1/tg/skills').then((resp: any) => {
            if (resp && resp.status === 1) {
              setSkillList(resp.data);
            }
          })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    

    const contractMetadataHistory = (versionKey: any) => {
        let data = { 
            candidateJobId: candidateJobId,
            version : versionKey - 1,
        }
        getContractMetadataHistory(data).then((response)=> {
            if(response && response.status === 1){
                setcontractSigned(response.data[0].contractSigned)
            }
        })
    } 

    const getContractDetails = () => {
        let body = {
            candidateJobId: candidateJobId
        }
        postAPI( REACT_APP_CONTRACT + `/contract-details`, body).then((resp: any) => {
            if(resp && resp.status === 1){
                setContractValues(resp.data[0].contractMetadata)
                setFullDetails(resp.data[0])
                setTerminateComment(resp.data[0].terminateComment)
                setSigned(resp.data[0].contractSigned)
                setRevisedContract(resp.data[0].revisedContract)    
                setContractInitiatedDate(resp.data[0].contractInitiatedDate)
                setEmployeeId(resp.data[0].employeeId)
                setRevisedCheckValues({
                    startDate: resp.data[0].contractMetadata.contractStartDate,
                    endDate: resp.data[0].contractMetadata.contractEndDate,
                    candidateRate: resp.data[0].contractMetadata.ellowRate,
                    resourceCost: resp.data[0].contractMetadata.contractRate
                })
                if (resp.data[0].contractSigned) {
                    setSignedDetails(resp.data[0].contractSignDetails)
                }
                let ProjectBody = {
                    projectId: resp.data[0].projectId,
                    projectName: resp.data[0].projectName,
                    reportingManagerEmail: resp.data[0].reportingManagerEmail,
                    reportingManagerName: resp.data[0].reportingManagerName
                }
                setProjectValues(ProjectBody)
                let allIds = {
                    candidateId: resp.data[0].candidateId,
                    jobId: resp.data[0].jobId,
                    contractId: resp.data[0].contractMetadata.contractId,
                    customerId: resp.data[0].customerId
                }
                setIdGroup(allIds)
                contractMetadataHistory(resp.data[0].version)
                if( resp.data[0].timesheetStatusList &&  resp.data[0].timesheetStatusList.length > 0 ){
                    let length = resp.data[0].timesheetStatusList.length
                    // console.log('getMilliSecUTC(new Date())', getMilliSecUTC(new Date()));
                    // console.log('resp.data[0].contractMetadata.contractEndDate', resp.data[0].contractMetadata.contractEndDate);
                    // if(new Date().getMonth() <= resp.data[0].contractMetadata.contractEndDate){
                    //     setTimesheetSubmitted(false)
                    // }else
                     if((new Date().getMonth() === resp.data[0].contractMetadata.contractEndDate || new Date().getMonth() > resp.data[0].contractMetadata.contractEndDate ) && (resp.data[0].timesheetStatusList[length - 1].timesheetStatus === '2' || resp.data[0].timesheetStatusList[length - 1].timesheetStatus === '3')){
                        setTimesheetSubmitted(false)
                    }
                    
                    
                    // setTimesheetSubmitted((new Date().getMonth() <= resp.data[0].contractMetadata.contractEndDate) && (resp.data[0].timesheetStatusList[length - 1].timesheetStatus === '2' || resp.data[0].timesheetStatusList[length - 1].timesheetStatus === '3'))
                }
            }
        })
    }

    const getPreviousContract = () => {
        let body = {
            candidateJobId: candidateJobId,
            version: version.toString()
        }
        previousContractDetails(body).then((response) => {
            if(response && response.status === 1 ){
                setContractValues(response.data[0].contractMetadata)
                setFullDetails(response.data[0]) 
                setEmployeeId(response.data[0].employeeId)
            }
        })
    }

    const getProjectsList = (customerId: string) => {
        getProjects(customerId).then((response: any) => {
        setProjectList(response.data)
    })
    }

    const uploadFile = (e: any) => {
        let fileExtension = e.target.files[0].name.split(".").pop();
        if (fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx") {
    
          let file = e.target.files[0]
          let type = file.type
    
          let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");
    
          let value = {
            "action": "putObject",
            "filename": fileName
          }
    
          postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resume-signed-url', value).then((data) => {
            let signedUrl = data.url;
            uploadApi(signedUrl, file, type).then((response: any) => {
            //   setDocument(fileName)
            //   setValue('supportingDocument', fileName.slice(36, fileName.length))
            })
          })
        }
      }

    const takeAction = (decisionValue: string) => {
        setButtonName(decisionValue)
        getProjectsList(IdGroup.customerId)
        switch(decisionValue){
            case 'Extend contract':
                setContractDetails(true)
                contractValues.contractStartDate = contractValues.contractEndDate + 86400000
                contractValues.contractEndDate = getMilliSecUTC(new Date())
                contractValues.duration = ''
                setContractValues(contractValues)
                return
            case 'End contract':
                setConfirmationModal(true)
                return
            case 'Edit contract':
                setContractDetails(true)
                return
            case 'Initiate agreement':  
                let value = {
                    candidateName: fullDetails && fullDetails.candidateName,
                    companyName: fullDetails && fullDetails.companyName,
                    startDate: contractValues && contractValues.contractStartDate,
                    candidateRole: fullDetails && fullDetails.jobRole,
                    endDate: contractValues && contractValues.contractEndDate,
                    monthlySalary: contractValues && contractValues.contractRate,
                    candidateEmail: fullDetails && fullDetails.email,
                    candidateJobId: candidateJobId,
                    billingType: contractValues && contractValues.billingType,
                    currencyType: contractValues && contractValues.currencyType,
                    candidateId: IdGroup.candidateId,
                    action: fullDetails && fullDetails.action,
                    version: fullDetails && fullDetails.version,
                    prevCandidateJobId: prevCandidateJobId,
                    revised: fullDetails.revisedContract
                }    
                setAgreementValues(value)
                setAgreement(true)
                return
           
            
        }
    //   submit()
    //   onClose()
    }

    const agreementClose = (message?: string) => {
        setAgreement(false)
        if (message && message === 'true') {
            setMessage('Agreement submitted successfully and Email is successfully sent')
            setNotification(true)
            setType('success')
            setIcon(true)
            setTimeout(() => {
              setNotification(false)
            }, 3000);
        }
    }

    const submitProject = (data: any) => {
        let body = {
      
            "action": "add",
            "projectId": data.projectId,
            "projectName": data.projectName,
            "customerId": IdGroup.customerId,
            "reportingManagerName": data.reportingManagerName,
            "reportingManagerEmail": data.reportingManagerEmail,
            "userLoginId": localStorage.getItem('loginId')   
        }
        updateProject(body).then((response: any) => {
        })
    }

    const submitContractDetails = (data: any) => {

        let revisedContract = false;

        if ((data.contractStartDate !== revisedCheckValues.startDate) || (data.contractEndDate !== revisedCheckValues.endDate) || parseInt(data.ellowRate) !== revisedCheckValues.candidateRate || parseInt(data.contractRate) !== revisedCheckValues.resourceCost) {
            revisedContract = true;
        }
        
        switch(buttonName){
            case 'Edit contract':
                let contractValue = {
                    "userLoginId": localStorage.getItem("loginId"),
                    "jobId": IdGroup.jobId,
                    "revisedContract": revisedContract,
                    "candidateId": IdGroup.candidateId,
                    "historyFlag": data.history,
                    "projectId": data.projectName && data.projectName.projectId ? data.projectName.projectId : projectValues.projectId,
                    "candidateJobId": candidateJobId,
                    "contractMetadata":{
                        "contractId": IdGroup.contractId,
                        "candidateCompanyEmail": data.candidateCompanyEmail !== "" ? data.candidateCompanyEmail : fullDetails.contractMetadata && fullDetails.contractMetadata.candidateCompanyEmail,
                        "contractStartDate": data.contractStartDate,
                        "contractEndDate": data.contractEndDate,
                        "duration": data.duration,
                        "contractRate": parseInt(data.contractRate),
                        "currencyType": data.currencyType,
                        "billingType": data.billingType,
                        "closedBy": data.closedBy,
                        "ellowRate": parseInt(data.ellowRate),
                        "ellowBillingType": data.ellowBillingType,
                        "ellowCurrencyType": data.ellowCurrencyType,
                        "supportingDoc": data.supportingDocument,
                        "skills": data.skills,
                        "inContract": true,
                        "createdOn": data.createdOn,
                        "updatedOn": getMilliSecUTC(new Date()),
                    }
                }

                let body = {
                    "action": "update",
                    "projectId": data.projectName.projectId,
                    "projectName": data.projectName.projectName,
                    "customerId": IdGroup.customerId,
                    "reportingManagerName": data.reportingManagerName,
                    "reportingManagerEmail": data.reportingManagerEmail,
                    "userLoginId": localStorage.getItem('loginId')
                }    
                
                updateProject(body).then((resp: any) => {                            
                    if (resp && resp.status === 1) {                      
                        contractMetadata(contractValue).then((response: any) => {
                            if (response && response.status === 1) {
                                // setConfirmationModal(false)
                                mixpanelData('TG- Contract Edited', {
                                    'source': 'Recruiter edits contract',
                                    'distinct_id': localStorage.getItem('Email'),
                                    'skills': data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.name).toString(),
                                    "contractStartDate": data.contractStartDate,
                                    "contractEndDate": data.contractEndDate,
                                    "duration": data.duration,
                                    "contractRate": parseInt(data.contractRate),
                                    "currencyType": data.currencyType,
                                    "billingType": data.billingType,
                                    "closedBy": data.closedBy,
                                    "ellowRate": parseInt(data.ellowRate),
                                    "ellowBillingType": data.ellowBillingType,
                                    "ellowCurrencyType": data.ellowCurrencyType,
                                    "candidateCompanyEmail": data.candidateCompanyEmail
                                })
                                mixpanelData('Test- Contract Edited', {
                                    'source': 'Recruiter edits contract',
                                    'distinct_id': localStorage.getItem('Email'),
                                    'Skills': data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.name),
                                    "Contract StartDate": data && data.contractStartDate ? new Date(data && data.contractStartDate).toDateString() : 'NA',
                                    "Contract EndDate": data && data.contractEndDate ? new Date(data && data.contractEndDate).toDateString() : 'NA',
                                    "Duration": data.duration,
                                    "Resource cost": parseInt(data.contractRate),
                                    "Currency type": data.currencyType,
                                    "Billing type": data.billingType,
                                    "Closed By": data.closedBy,
                                    "ellow Rate": parseInt(data.ellowRate),
                                    "ellow Billingtype": data.ellowBillingType,
                                    "ellow Currencytype": data.ellowCurrencyType,
                                    "Candidate company email": data.candidateCompanyEmail,
                                    'Candidate loginid': localStorage.getItem("loginId"),
                                    "Project name": data.projectName.projectName,
                                    'jobId': IdGroup.jobId,
                                    "Reporting Manager name": data.reportingManagerName,
                                    "Reporting Manager email": data.reportingManagerEmail,
                                    "Sign In date": data.signInDate ? new Date(data.signInDate).toDateString() : 'NA',
                                })
                                getTableValues()
                                setContractDetails(false)
                                getContractDetails()
                                contractMetadataHistory(response.data[0].version)
                            }
                            else {
                                setDisableButton(true)
                            }
                        })
                    }
                })
                return
            case 'Extend contract':
                let extendcontractValues = {
                    "userLoginId": localStorage.getItem("loginId"),
                    "jobId": IdGroup.jobId,
                    "candidateId": IdGroup.candidateId,
                    "projectId": data.projectName && data.projectName.projectId ? data.projectName.projectId : projectValues.projectId,
                    "previousCandidateJobId": candidateJobId,
                    "contractMetadata":{
                        "contractId": IdGroup.contractId,
                        "candidateCompanyEmail": data.candidateCompanyEmail !== "" ? data.candidateCompanyEmail : fullDetails.contractMetadata && fullDetails.contractMetadata.candidateCompanyEmail,
                        "contractStartDate": data.contractStartDate,
                        "contractEndDate": data.contractEndDate,
                        "duration": data.duration,
                        "contractRate": parseInt(data.contractRate),
                        "currencyType": data.currencyType,
                        "billingType": data.billingType,
                        "closedBy": data.closedBy,
                        "ellowRate": parseInt(data.ellowRate),
                        "ellowBillingType": data.ellowBillingType,
                        "ellowCurrencyType": data.ellowCurrencyType,
                        "supportingDoc": data.supportingDocument,
                        "skills": data.skills,
                        "inContract": true,
                        "createdOn": data.createdOn,
                        "updatedOn": getMilliSecUTC(new Date()),
                        
                    }
                }
                postAPI( REACT_APP_CONTRACT + `/contract-extend`, extendcontractValues).then((resp: any) => {
                    if( resp && resp.status === 1){
                        mixpanelData('TG- Contract Extended', {
                            'source': 'Recruiter extends contract',
                            'distinct_id': localStorage.getItem('Email'),
                            'skills': data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.name).toString(),
                            "contractStartDate": data.contractStartDate,
                            "contractEndDate": data.contractEndDate,
                            "duration": data.duration,
                            "contractRate": parseInt(data.contractRate),
                            "currencyType": data.currencyType,
                            "billingType": data.billingType,
                            "closedBy": data.closedBy,
                            "ellowRate": parseInt(data.ellowRate),
                            "ellowBillingType": data.ellowBillingType,
                            "ellowCurrencyType": data.ellowCurrencyType,
                            "candidateCompanyEmail": data.candidateCompanyEmail
                        })
                        mixpanelData('New TG - Contract Extended', {
                            'source': 'Recruiter extends contract',
                            'distinct_id': localStorage.getItem('Email'),
                            'Skills': data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.name),
                            "contractStartDate": new Date(data.contractStartDate).toDateString(),
                            "contractEndDate": new Date(data.contractEndDate).toDateString(),
                            "Duration": data.duration,
                            "contractRate": `${parseInt(data.contractRate)} ${data.currencyType} / ${data.billingType}`,
                            // "currencyType": data.currencyType,
                            // "billingType": data.billingType,
                            "ellowRate": `${parseInt(data.ellowRate)} ${data.ellowCurrencyType} / ${data.ellowBillingType}`,
                            "candidateCompanyEmail": data.candidateCompanyEmail,
                            'Candidate loginid': fullDetails.candidateId,
                            'jobId': IdGroup.jobId,
                            'Job name': fullDetails.jobRole,
                            'Company name': fullDetails.companyName,
                            'Candidate name': fullDetails.candidateName,
                            'Candidate email': fullDetails.email,
                            "Closed by": data.closedBy,
                            'Project name': fullDetails.projectName,
                            'Reporting Manager Name': fullDetails.reportingManagerName,
                            'Reporting Manager Email': fullDetails.reportingManagerEmail,
                            "Contract id": IdGroup.contractId,
                            "Sign In date": data.signInDate ? new Date(data.signInDate).toDateString() : 'NA',
                        })
                        setConfirmationModal(false)
                        getTableValues()
                        setContractDetails(false)
                        getContractDetails()
                    }
                })
                return
            case 'End contract':
                let terminateBody = {
                    candidateJobId : candidateJobId,
                    comment: data.comment,
                    contractEndDate: Utils.getMilliSecUTC(data.date),
                    userLoginId: localStorage.getItem('loginId')
                }
                postAPI( REACT_APP_CONTRACT + `/contract-terminate`, terminateBody).then((resp: any) => {
                    if( resp && resp.status === 1){
                        setConfirmationModal(false)
                        getTableValues()
                        setContractDetails(false)
                        getContractDetails()
                        mixpanelData('TG- Contract terminated', {
                            'source': 'Recruiter edits contract',
                            'distinct_id': localStorage.getItem('Email'),
                            'contractEndDate': new Date(data.date).toDateString(),
                            'comment': data.comment
                        })
                        mixpanelData('Test- Contract terminated', {
                            'source': 'Recruiter terminates contract',
                            'distinct_id': localStorage.getItem('Email'),
                            'Contract EndDate': new Date(data.date).toDateString(),
                            'Reason': data.comment,
                            'Candidate JobId': data.candidateJobId,
                            'Contract Rate': resp.data[0].contractRate,
                            'Recruiter email': localStorage.getItem('Email'),
                            'Job name': fullDetails.jobRole,
                            'Company name': fullDetails.companyName,
                            'Candidate name': fullDetails.candidateName,
                            'Candidate email': fullDetails.email,
                            'Position id': fullDetails.jobId,
                            'Candidate loginid': fullDetails.candidateId
                        })
                    }
                })
                return      
        }
    }

    const viewContract = () => {
       let fileName = signDetails && signDetails.documentname
            let value = {
              "action": "getObject",
              "filename": `contractAgreementLetters/${fileName}`,
              "bucketName": "ellow-prod-doc-upload",
            };
            
            postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resume-signed-url', value).then((data) => {
              let signedUrl = data.url;
              fetch(signedUrl).then((response: any) => {
        
                response.blob().then((blob: any) => {
                    const fileURL = window.URL.createObjectURL(blob);
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download =`k.pdf`;
                    alink.click();
                })
            })
            })
          
    }


    return (
      <Modal title="" size="medium" onClose={onClose}>
        {contractDetails && <ContractDetails 
            onClose={() => {setContractDetails(false); getContractDetails()}} 
            allocatedTo={allocatedTo} 
            ClickHandler={submitContractDetails} 
            defaultvalues={contractValues} 
            buttonName={buttonName}
            projectData={projectValues} 
            projectList={projectList}    
            submitAddProject={submitProject}
            closed={closed}
            disableButton={disableButton}
            terminateComment={terminateComment}
            getProjectDetailsById={getProjectDetails}
            timesheetSubmitted={timesheetSubmitted}
            skillsList={skillList}
            // jobMetadata={props.jobMetadata} 
            // contractEndDate={contractEndDate}
        />}
        {confirmationModal && <ConfirmationModal 
            onClose={() => setConfirmationModal(false)}
            submit={submitContractDetails}
            // getTableValues={getTableValues}
            />}
            
        {notification && (
          <NotificationAlert
            onClose={() => setNotification(false)}
            closable={true}
            type={type}
            icon={icon}
          >
            {message}
          </NotificationAlert>
        )}

            {agreement && <ContractAgreement onClose={agreementClose} defaultValues={agreementValues} agreementValues={agreementValues} />}
            
        <div className={Styles.resourceTitle}>
            <h3 >
                    {fullDetails && fullDetails.candidateName} - <span>{fullDetails && fullDetails.jobRole}</span>
            </h3>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <p>email: <a href="">{fullDetails && fullDetails.email}</a></p>
            </div>
             {hrEmail === true && prevContract !== true && <div>
                {contractInitiatedDate !== null && <p className={Styles.subAction}>Last send on : {new Date(parseInt(contractInitiatedDate)).toDateString().slice(3)}</p>}
                <div className={Styles.subActionTop}>
                 {!signed && <Button variant='secondary' onClick={() => takeAction('Initiate agreement')}>{revisedContract ? 'Initiate revised Contract' : 'Initiate contract'}</Button> }
                </div>
                </div>
            } 
            {
                hrEmail === true && (signed || contractSigned) && 
                <div className={Styles.viewContract}>
                     {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a  onClick={viewContract}><Icon icon="material-symbols:clinical-notes-outline" />View Contract </a>
                </div> 
            } 
        <div className={Styles.basicInfoCard}>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                        <label>Skills:</label>
                        {contractValues && contractValues.skills && contractValues.skills.length > 0 && contractValues.skills.map((item: any) => item.name).toString()}
                </div>
                <div className={Styles.form}>
                    <label>Start Date:</label>
                    {contractValues && contractValues.contractStartDate && new Date(contractValues.contractStartDate).toDateString().slice(3)}
                </div>
            </div>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                <label>Duration:</label>
                {contractValues && contractValues.duration}
                </div>
                <div className={Styles.form}>
                <label>End Date:</label>
                {contractValues && contractValues.contractEndDate && new Date(contractValues.contractEndDate).toDateString().slice(3)}
                </div>
            </div> 
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                    <label>Contract signed on:</label>
                    {contractValues && contractValues.createdOn && new Date(contractValues.createdOn).toDateString().slice(3)}
                </div>
                <div className={Styles.form}>
                    <label>Resource cost:</label>
                    {contractValues && contractValues.contractRate + '  ' + contractValues.currencyType + '/' + contractValues.billingType}
                </div>
            </div>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                    <label>Position closed by:</label>
                  {contractValues && contractValues.closedBy}
                </div>
                <div className={Styles.form}>
                    <label>ellow rate:</label>
                    {contractValues && contractValues.ellowRate + '  ' + contractValues.ellowCurrencyType + '/' + contractValues.ellowBillingType}
                </div>
            </div>
            <div className={Styles.cardItrem}>
                <div className={Styles.form}>
                    <label>Reporting manager name:</label>
                  {fullDetails && fullDetails.reportingManagerName}
                </div>
                <div className={Styles.form}>
                        <label>Project:</label>
                        {fullDetails && fullDetails.projectName}
                </div>
                </div>
                <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                        <label>Reporting manager email:</label>
                            {fullDetails && fullDetails.reportingManagerEmail}
                    </div> 
                    <div className={Styles.form}>
                        <label>Employee Id:</label>
                        {employeeId}
                    </div> 
                </div>      
            </div> 
            
        { hrEmail === false &&  
            <div className="subAction">
                <div className={Styles.popupAction}>
                    <Button variant='secondary'  onClick={onClose}>Cancel</Button>
                </div>
            </div>
        }
        { hrEmail === true &&  
            <div className="subAction">  
                {prevContract !== true && <>
                    <div className={Styles.uploadButton}>
                        {/* <Button variant='secondary' onClick={ }>Upload signed document</Button>    */}
                        <UploadFiled content="Upload signed document" uploadFile={uploadFile}/> 
                    </div>      
                    { fullDetails && fullDetails.inContract && <Button variant='delete' onClick={() => takeAction('End contract')}>End Contract</Button>}
                    <div className={Styles.popupAction}>
                        <Button variant='secondary'  onClick={onClose}>Cancel</Button>
                        <Button variant='secondary' onClick={() => takeAction('Edit contract')} >Edit contract</Button>
                        <Button variant='primary' onClick={() => takeAction('Extend contract')} >Extend contract</Button>    
                    </div>
                </>}   
                {prevContract === true && <>
                    <div className={Styles.popupAction}>
                        <Button variant='secondary'  onClick={onClose}>Cancel</Button>
                    </div>
                </>} 
            </div> 
        }
    </Modal>
    )
}
export default  ResourceInfoModal

